'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Group = require('./Group');

var _Group2 = _interopRequireDefault(_Group);

var _InputJson = require('./InputJson');

var _InputJson2 = _interopRequireDefault(_InputJson);

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.ControlJson',

  propTypes: {
    name: _react.PropTypes.string.isRequired,
    value: _react.PropTypes.any.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },

  render: function render() {
    var _props = this.props;
    var name = _props.name;
    var value = _props.value;
    var onChange = _props.onChange;

    return _react2['default'].createElement(
      _Group2['default'],
      { name: name },
      _react2['default'].createElement(_InputJson2['default'], { value: value, onChange: onChange })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/ControlJson.js
// module id = 958
// module chunks = 0